// Copyright (C) 2021 Bystronic Laser AG

import { metricsService } from '@/services/metrics.service';
import { FilterTimeSpanEnum } from '../enums/FilterTimeSpanEnum';
import { WidgetEnum } from '../enums/WidgetEnum';
import { DataRetriever } from './abstract/chartGenerator';
import { CurrentBendPlanData } from '@/models/deviceStateData';

/**
 * Used by (new) bend device cards to retrieve data about the current plan.
 */
export class CurrentBendPlanDataRetriever extends DataRetriever<CurrentBendPlanData> {
  constructor(private customerIdDh: number) {
    super(WidgetEnum.OverviewBendCurrentPlan);
  }

  override async getData(
    selectedDevices: string[],
    selectedShifts: number[],
    timeSpan: FilterTimeSpanEnum | [string, string],
  ): Promise<CurrentBendPlanData | null> {
    return await metricsService.getBendingDevicesMetrics(
      this.procedure,
      {
        customerIdDh: this.customerIdDh,
        deviceStringIds: selectedDevices,
      },
      this.controller,
    );
  }

  async getDataForDevice(device: string): Promise<CurrentBendPlanData | null> {
    // We get the current plan, independently of the shift and time span
    return this.getData([device], [], FilterTimeSpanEnum.None);
  }
}
